export const appSyncApiConfig = {
  baseUrl: process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT,
  apiKey: process.env.REACT_APP_AWS_APPSYNC_APIKEY,
}
